// extracted by mini-css-extract-plugin
export default {"Observation":"VDCCaseJurisprudence_Observation__ymtjD","Noobservation":"VDCCaseJurisprudence_Noobservation__NfxdA"};